module.exports = __webpack_public_path__ + "img/netlify_logo_icon.722adc99.png";